const roleHierarchy = {
  member: 1,
  admin: 2,
};

interface UserModel {
  id: string;
  name: string;
  email: string;
  role: "admin" | "member";
  created_at: string;
}

export { roleHierarchy };
export type { UserModel };
